module.exports = __webpack_public_path__ + "img/icon-btn.c04f5c07.png";